import styles from './EmailTag.module.css';

export type TagVariant = 'new-customer' | 'order' | 'order-detected' | 'order-submitted' | 'order-confirmed' | 'order-shipped' | 'order-completed' | 'order-cancelled' | 'order-failed' | 'order-draft' | 'urgent' | 'assigned' | 'awaiting' | 'unassigned' | 'state' | 'info' | 'internal' | 'confidence-high' | 'confidence-medium' | 'confidence-low' | 'dup-po' | 'ai-drafting' | 'ai-failed' | 'change-proposed' | 'change-applied' | 'change-settled';

interface EmailTagProps {
  variant: TagVariant;
  label: string;
  /** Optional hover tooltip — used to surface longer detail behind a compact badge. */
  title?: string;
}

const EmailTag: React.FC<EmailTagProps> = ({ variant, label, title }) => {
  const variantMap: Record<TagVariant, string> = {
    'new-customer': styles.newCustomer,
    'order': styles.order,
    'order-detected': styles.orderDetected,
    'order-submitted': styles.orderSubmitted,
    'order-confirmed': styles.orderConfirmed,
    'order-shipped': styles.orderShipped,
    'order-completed': styles.orderCompleted,
    'order-cancelled': styles.orderCancelled,
    'order-failed': styles.orderFailed,
    'order-draft': styles.orderDraft,
    'urgent': styles.urgent,
    'assigned': styles.assigned,
    'awaiting': styles.awaiting,
    'unassigned': styles.unassigned,
    'state': styles.state,
    'info': styles.info,
    'internal': styles.info,
    'confidence-high': styles.confidenceHigh,
    'confidence-medium': styles.confidenceMedium,
    'confidence-low': styles.confidenceLow,
    'dup-po': styles.dupPo,
    'ai-drafting': styles.aiDrafting,
    'ai-failed': styles.aiFailed,
    'change-proposed': styles.changeProposed,
    'change-applied': styles.changeApplied,
    'change-settled': styles.changeSettled,
  };

  return (
    <span className={`${styles.tag} ${variantMap[variant]}`} title={title}>
      {label}
    </span>
  );
};

export default EmailTag;
